import React, { useEffect, useState } from 'react';
import CenterSpinner from '../../components/CenterSpinner';
import { Label } from 'reactstrap';
import KTable from '../../components/KTable';
import KPagination from '../../components/KPagination';
import { PaginationType, TrackCompliantFilterType } from '../../utils/Types';
import { DEFAULT_PAGE_SIZE } from '../../utils/Constant';
import { TRACK_COMPLIANT_HEADER } from './TrackCompliantHelper';
import TrackCompliantFilter from '../../filters/TrackCompliantFilter';
import TrackCompliantModal from '../modals/TrackCompliantModal';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  getComplaintsList,
  trackComplaintsSelector,
} from '../../features/trackComplaintsSlice';
import moment from 'moment';
import ToggleSwitch from '../../components/ToggleSwitch';
import classNames from 'classnames';
import { useLoader } from '../../loader/LoaderProvider';

const TrackCompliantListPage: React.FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const { showLoader, setShowLoader } = useLoader();
  const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedFilter, setSelectedFilter] =
    useState<TrackCompliantFilterType>();
  const [selectedComplaintId, setSelectedComplaintId] = useState<
    string | number | null
  >();
  const [showFilter, setShowFilter] = useState<boolean>(true);

  const disptach = useAppDispatch();
  const complaintsList = useAppSelector(trackComplaintsSelector)
    .trackComplaintsData.result;
  const pagination: PaginationType = useAppSelector(trackComplaintsSelector)
    .trackComplaintsData.pagination;
  const onTableAction = (param: any) => {
    setSelectedComplaintId(param.complaintUniqueId);
    setIsModalOpen(!isModalOpen);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setSelectedComplaintId(null);
  };

  const getTrackComplaintsList = () => {
    const data: any = {};
    if (selectedFilter?.assignTo?.value)
      data.assignedToId = selectedFilter.assignTo.value;
    if (selectedFilter?.severity?.value)
      data.severityId = selectedFilter.severity.value;
    if (selectedFilter?.zone?.value) {
      data.zone = selectedFilter.zone.value;
    }
    if (selectedFilter?.state?.value) {
      data.state = Number(selectedFilter.state.value);
    }
    if (selectedFilter?.district?.value) {
      data.district = Number(selectedFilter.district.value);
    }
    if (selectedFilter?.city?.value) {
      data.city = Number(selectedFilter.city.value);
    }
    if (selectedFilter?.startDate) {
      data.fromDate = moment(selectedFilter.startDate).format('YYYY-MM-DD');
    } else {
      data.fromDate = moment().format('YYYY-MM-DD');
    }
    if (selectedFilter?.endDate) {
      data.toDate = moment(selectedFilter.endDate).format('YYYY-MM-DD');
    } else {
      data.toDate = moment().format('YYYY-MM-DD');
    }
    if (selectedFilter?.status?.value) {
      data.complaintStatus = selectedFilter.status.value;
    }
    data.pageNumber = currentPage;
    data.pagePerCount = pageSize;
    setShowLoader(true);
    disptach(getComplaintsList(data))
      ?.then(() => {
        setShowLoader(false);
      })
      ?.catch(() => {
        setShowLoader(false);
      });
  };

  useEffect(() => {
    getTrackComplaintsList();
  }, [selectedFilter, pageSize, currentPage]);

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <div className="ml-4">
      <Label className="text-heading">Track Complaint</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
      <div className="task-item-parent-view">
        {showFilter && (
          <TrackCompliantFilter
            onApplyFilters={(filter) => {
              setSelectedFilter(filter);
              setCurrentPage(1);
            }}
          />
        )}
        <div className="mt-4">
          <KTable
            data={complaintsList}
            columnHeader={TRACK_COMPLIANT_HEADER}
            onAction={onTableAction}
            tableParentClass={classNames('table-parent-track-complaint', {
              hideFilters: !showFilter,
            })}
            isLoading={showLoader}
          />
          {complaintsList && complaintsList.length > 0 && (
            <KPagination
              currentPage={pagination?.currentPage}
              pageSize={pagination?.pageSize}
              onPageChange={setCurrentPage}
              onSizeChange={setPageSize}
              fromItem={pagination?.fromItem}
              toItem={pagination?.toItem}
              totalItems={pagination?.totalItems}
            />
          )}
        </div>
        <TrackCompliantModal
          isOpen={isModalOpen}
          toggleModal={toggleModal}
          complaintId={selectedComplaintId}
        />
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      </div>
    </div>
  );
};

export default TrackCompliantListPage;
